<div mat-icon-button class="profile-image-wrapper">
    <app-video-player [videoSources]="videoSource" [videoId]="'singleVideo'" (vgApiEmitter)="onPlayerReady($event)">
    </app-video-player>
</div>
